export default "__VITE_ASSET__CDqzyHDn__"